import React from "react";
import { createContext, useContext, useState } from "react";
import { getSelectedLanguage } from "../../helper/helper";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [selectedLanguage, setSelectedLanguage] = useState(() => {
        return getSelectedLanguage();
    });
    const languagePrefix = selectedLanguage?.toLowerCase() === 'en' || selectedLanguage?.toLowerCase() === 'fr' ? '' : '/sw';

    return (
        <LanguageContext.Provider value={{ languagePrefix, selectedLanguage, setSelectedLanguage }}>
            {children}
        </LanguageContext.Provider>
    )
}
export const useLanguage = () => useContext(LanguageContext)

